import {
  LOGIN_USER_SUCCESS,
  LOGOUT,
  DEVICE_TOKEN,
  SELECT_SHARED_ACCOUNT_USER,
} from '../actions/authActions';

const storedUser = JSON.parse(sessionStorage.getItem("user"));

const INITIAL_STATE = {
  user: storedUser,
  deviceToken: '',
  isAuthenticated: !!storedUser,
  isAdmin: storedUser?.isAdmin || false,
  loading: false,
  error: null,
  selectedUser: null,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER_SUCCESS:
      sessionStorage.setItem("user", JSON.stringify(action.payload)); // persist
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        isAdmin: action.payload?.isAdmin || false,
        loading: false,
      };
    case DEVICE_TOKEN:
      return { ...state, deviceToken: action.payload };

    case SELECT_SHARED_ACCOUNT_USER:
      return { ...state, selectedUser: action.payload };
    case LOGOUT:
      sessionStorage.removeItem("user");
      return INITIAL_STATE;

    default:
      return state;
  }

};

export default authReducer;
